/**
 * Cross-browser range sliders — game-styled track/thumb + soft tick while dragging.
 */

import { playUiSliderTick } from "./ui-sounds";

const RANGE_SELECTOR = 'input[type="range"]';

function decorateRangeInput(input: HTMLInputElement): void {
    if (input.classList.contains("gameRange")) return;
    input.classList.add("gameRange");
    input.addEventListener("input", () => playUiSliderTick(), { passive: true });
}

export function mountGameRangeSliders(root: ParentNode = document): void {
    root.querySelectorAll<HTMLInputElement>(RANGE_SELECTOR).forEach(decorateRangeInput);
}

export function observeGameRangeSliders(): void {
    mountGameRangeSliders();
    const observer = new MutationObserver((mutations) => {
        for (const m of mutations) {
            for (const node of m.addedNodes) {
                if (node instanceof HTMLInputElement && node.type === "range") {
                    decorateRangeInput(node);
                } else if (node instanceof Element) {
                    mountGameRangeSliders(node);
                }
            }
        }
    });
    observer.observe(document.body, { childList: true, subtree: true });
}
